export function isApiError(error) {
    // for some reason `return axios.isAxiosError(error);` doesnt work properly
    // typing for ApiError is also incorrect, hope it wont explode in the future
    return error.name === 'AxiosError';
}
